import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';
import { campaignsApi, type Campaign } from '../campaignsApi';
import { useSessionStore } from '../../../stores/sessionStore';
import { getAuthHeaders } from '../../../services/http';
import './campaign-status.css';

export function CheckCampaignStatusButton({ campaign }: { campaign: Campaign }) {
  const token = useSessionStore(state => state.session?.access_token);
  const tenantId = useSessionStore(state => state.activeTenantId);
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () => campaignsApi.checkOriginStatus(campaign.id, { headers: getAuthHeaders(token!) }),
    onSuccess: result => {
      queryClient.setQueriesData<{ items: Campaign[] }>({ queryKey: ['campaigns', token, tenantId], exact: true }, previous =>
        previous ? { ...previous, items: previous.items.map(item => item.id === campaign.id
          ? { ...result.campaign, primary_asset_url: result.campaign.primary_asset_url || item.primary_asset_url } : item) } : previous);
      queryClient.setQueryData(['campaign', campaign.id], result.campaign);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns', token, tenantId], exact: true });
      queryClient.invalidateQueries({ queryKey: ['campaign', campaign.id] });
    },
  });
  const busy = [campaign.meta_sync_status, campaign.google_sync_status].some(status =>
    ['syncing', 'publishing', 'status_changing'].includes(status || ''));
  if (!campaign.meta_campaign_id && !campaign.google_campaign_id) return null;
  const errors = [campaign.meta_status_check_error && `Meta Ads: ${campaign.meta_status_check_error}`,
    campaign.google_status_check_error && `Google Ads: ${campaign.google_status_check_error}`].filter(Boolean);
  return <div className="campaign-status-check" onClick={event => event.stopPropagation()}>
    <button type="button" className="campaign-origin-link" disabled={!token || busy || mutation.isPending}
      title="Consultar a Meta e o Google sem alterar a veiculação" onClick={() => mutation.mutate()}>
      <RefreshCw size={13} className={mutation.isPending ? 'spin' : undefined}/>
      {mutation.isPending ? 'Consultando origens...' : 'Consultar status nas origens'}
    </button>
    {mutation.isError && <span role="alert" className="campaign-status-error">{mutation.error.message}</span>}
    {errors.map((error, index) => <span key={index} role="alert" className="campaign-status-error">{error}</span>)}
  </div>;
}
